<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { UsageCollectorApp } from './UsageCollectorApp';
    import { api } from '../../../stores/api';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import ModalExtraData from '../EasyVrp/ModalExtraData.svelte';
    import WebuserList from './WebuserList.svelte';

    let usageApp: UsageCollectorApp = new UsageCollectorApp($api);

    onMount(() => {
        usageApp
            .load()
            .then(() => {
                usageApp = usageApp;
            })
            .catch(error => {
                console.error('Error loading UsageCollectorApp:', error);
            });
    });
</script>

<div>
    {#if usageApp.isLoading()}
        <div>
            <p>Loading usage data...</p>
            <IconPending scale={0.6} spin={true} />
        </div>
    {:else if usageApp.hasError()}
        <p>Error loading usage data: {usageApp.getError()}</p>
    {:else}
        {#each usageApp.getUniqueMonths() as month}
            <div class="usage-item">
                <h3>{month}</h3>
                <table class="table-usage">
                    <thead>
                    <tr class="usage-item">
                        <th>CustomerId</th>
                        <th>Nazwa</th>
                        <th>{$_('vehicles_count_header')}</th>
                        <th>{$_('deliveries')}</th>
                        <th>{$_('pickups')}</th>
                        <th>{$_('downloaded_routes')}</th>
                        <!--                        <th></th>-->
                    </tr>
                    </thead>
                    <tbody>
                    {#each usageApp.getUsageData() as usageRow}
                        {#if month === usageRow.month}
                            <tr class="usage-item usage-row-clickable" on:click={()=>{
                                        openModal(ModalCustom, {
                                            component: WebuserList,
                                            componentProps: {
                                                customer_name: usageRow.customer_name,
                                                month: usageRow.month,
                                                customer_id: usageRow.customer_id,
                                                vehicles: JSON.parse(usageRow.vehicle_json) || [],
                                            },
                                        });
                                    }}>
                                <td>#{usageRow.customer_id}</td>
                                <td>{usageRow.customer_name}</td>
                                <td>{usageRow.unique_vehicle_count}</td>
                                <td>{usageRow.delivery_delivery_count}</td>
                                <td>{usageRow.delivery_collection_count}</td>
                                <td>{usageRow.route_load_count}</td>
                                <!--                                <td>{usageRow.unique_assignment_count}</td>-->
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </div>
        {:else}
            <p>No usage data available.</p>
        {/each}
    {/if}
</div>

<style>
    .table-usage {
        width: 100%;
        border-collapse: collapse;
    }

    .usage-item th {
        padding: 0.5rem;
        border: 1px solid #ddd;
        text-align: right;
        font-weight: 200;
        opacity: 0.8;
    }

    .usage-item td {
        padding: 0.5rem;
        border: 1px solid #ddd;
        text-align: right;
    }

    .usage-row-clickable {
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

    .usage-row-clickable:hover {
        background-color: #f0f8ff;
    }
</style>
